import { CDN_BASE_URL } from "config";
import { motion } from "framer-motion";
import Reveal from "motion/Reveal";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const bubbles = [
  {
    src: "/logos/1 (1).png",
    className: "bubble-1 top-10 left-10",
  },
  {
    src: "/logos/1 (2).png",
    className: "bubble-2 top-[12%] right-16",
  },
  {
    src: "/logos/1 (8).png",
    className:
      "bubble-3 bottom-16 left-12 bg-black/80 rounded-full h-10 lg:h-16 object-contain px-1",
  },
  {
    src: "/logos/1 (4).png",
    className: "bubble-4 top-1/2 right-8",
  },
  {
    src: "/logos/1 (5).png",
    className: "bubble-5 top-[30%] left-[5%]",
  },
  {
    src: "/logos/1 (6).png",
    className:
      "bubble-6 bottom-8 right-14 bg-white/30 rounded-full h-10 lg:h-16 object-contain",
  },
  {
    src: "/logos/1 (7).png",
    className:
      "bubble-7 top-[18%] left-[20%] bg-white/30 rounded-full h-10 lg:h-16 object-contain px-1",
  },
  {
    src: "/logos/1 (3).png",
    className:
      "bubble-8 bottom-[20%] right-[18%] bg-white/30 rounded-full h-10 lg:h-16 object-contain px-1",
  },
  {
    src: "/logos/1 (9).png",
    className:
      "bubble-9 top-[5%] right-[8%] bg-white/30 rounded-full h-10 lg:h-16 object-contain",
  },
];

export default function FreeConsultationCTA({ service, locale }) {
  const { t } = useTranslation("global");
  return (
    <section className="bg-no-repeat bg-cover relative py-32 overflow-hidden bg-black">
      <img
        src="/contact-bg.jpg"
        className="absolute left-0 top-0 w-full h-full object-cover blur-[5px] "
      />
      {/* لوگوهای حبابی */}
      {bubbles.map((bubble, index) => (
        <motion.img
          key={index}
          src={bubble.src}
          alt="social medias logo"
          className={`absolute w-10 md:w-16 z-0  ${bubble.className}`}
          animate={{
            opacity: 0.8,
            scale: 1,
            x: [0, 10, 0, -10, 0],
            y: [0, -10, 0, 10, 0],
          }}
          transition={{
            duration: 6 + Math.random() * 3, // هر لوگو مدت متفاوت
            repeat: Infinity,
            ease: "easeInOut",
            delay: index * 0.5, // تاخیر برای جدا کردن حرکت‌ها
          }}
        />
      ))}

      {/* متن و دکمه مرکز */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-white text-4xl  lg:text-6xl font-bold  font-title mb-4"
        >
          {t("contact-title")}
          <br />
          <span className="text-blue-400">
            {service?.contacttitle2[locale]}
          </span>
        </motion.h2>
        <Reveal>
          <p
            className=" text-center mt-3 normal-case text-gray-100 text-[14px] lg:text-[18px] mb-8"
            dangerouslySetInnerHTML={{
              __html: t("contact-desc"),
            }}
          />
        </Reveal>
        <Reveal direction="right">
          <div className="flex justify-center">
            <Link
              to={"/contact"}
              className="bg-red-500 px-4 py-2 rounded-full text-white text-[16px]"
            >
              {t("menu-contact")}
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
